import React, {Fragment, useState} from 'react';
import classNames from "classnames";
import Icon from "../../../components/Icon";
import Avatar from "../../../components/Avatar";
// import DraftContentReader from "../../../components/editor/DraftContentReader";
import moment from "moment";
import DateSince from "../../../components/Date";
import {SpinLoader} from "../../../components/Loader";
import {Link} from "react-router-dom";
import createLink from "../../../../libs/createLink";
import _ from "lodash";
import {durationVideo} from "../../../../libs/helper";
import MessageContentReader from "./MessageContentReader/MessageContentReader";

const MessageWrapper = ({
                            message = {},
                            beforeMessage = null,
                            handleDelete = () => {
                            },
                            isRoomLock = false,
                            showDetails = false,
                            canDelete = false,
                            isGroup = false,
                            involve = false,
                            className,
                            children
                        }) => {
    let date = message.createdAt ? moment().diff(message.createdAt, 'hours') : '';
    return (
        <Fragment>
            {!involve && !message.isSameUser && <div className="mt-8"/>}
            <div className={classNames(
                "message-wrapper",
                {
                    'room-notification': involve,
                    'first-message-of-group': (!involve && beforeMessage && !beforeMessage.shortPeriod && beforeMessage.isSameUser), //todo hasMoreMessages
                    'regroup-messages': (!involve && message.shortPeriod && message.isSameUser),
                    leftside: !message.ownerIsCurrentUser,
                    rightside: message.ownerIsCurrentUser
                },
                className
            )}>
                {(!involve && !message.ownerIsCurrentUser && isGroup && !message.shortPeriod) &&
                <div className="message-owner">{message.owner.username}</div>}
                <div className="main-content row align-center">
                    {(!involve && message.ownerIsCurrentUser && canDelete && !isRoomLock) && (
                        <div className="delete-message"
                             onClick={() => handleDelete(message._id)}>
                            <Icon type="delete-message"/>
                        </div>
                    )}
                    <div className="content">
                        {(!involve && !message.ownerIsCurrentUser && !message.shortPeriod) &&
                        <Link to={createLink('userProfile', message.owner)} target={"_blank"}><Avatar gender={_.get(message, "owner.profile.gender")} avatar={_.get(message, "owner.profile.avatar")}/></Link>}
                        {children}
                        {message.isSend !== undefined && (<SpinLoader className={"not-sent"}/>)}
                    </div>
                </div>
                {showDetails && (
                    <div
                        className={classNames("message-time", {active: showDetails})}>
                        {date >= 1 ?
                            moment(message.createdAt).format("DD/MM/YYYY HH:mm")
                            :
                            <DateSince
                                date={message.createdAt}
                                prefix={true}
                                currentFormat={true}
                            />
                        }
                    </div>
                )}
            </div>
        </Fragment>
    )
}

const MessageInvolve = ({message, roomOwnerId}) => {
    return (
        <MessageWrapper
            involve={true}
            message={message}>
            {message.involve === "join" && (
                <div className="group-user-join">
                    <Icon type="plus"/> {message.owner.username} a rejoint le groupe
                </div>
            )}
            {message.involve === "leave" && (
                <div className="group-user-join">
                    <Icon
                        type={"sign-out"}/> {(message.owner._id === roomOwnerId || message.user._id === message.owner._id) ? `${message.owner.username} a quitté le groupe` : `${message.owner.username} a été retiré du groupe`}
                </div>
            )}
        </MessageWrapper>
    )
}

const MessageText = ({message, beforeMessage, isGroup, isRoomLock, handleDelete}) => {
    let [toggleShowDetail, setToggleShowDetails] = useState(false);
    return (
        <MessageWrapper
            message={message}
            isRoomLock={isRoomLock}
            beforeMessage={beforeMessage}
            handleDelete={handleDelete}
            canDelete={true}
            showDetails={toggleShowDetail}
            isGroup={isGroup}
        >
            <div className="column">
                <div className="message-content"
                     onClick={() => setToggleShowDetails(!toggleShowDetail)}>
                    <MessageContentReader message={message}/>
                    {/*<DraftContentReader contentRaw={message.contentRaw}/>*/}
                </div>
            </div>
        </MessageWrapper>
    )
}

const MessageRemove = ({message}) => {
    return (
        <MessageWrapper
            involve={true}
            message={message}>
            {message.isDeleted ? (
                <div className="group-user-join">
                    <Icon type="trash"/> Message supprimé
                </div>
            ) : null}
        </MessageWrapper>
    )
}

const MessageGallery = ({message, beforeMessage, isGroup, isRoomLock, handleDelete, handleOpenMedia}) => {
    return (
        <MessageWrapper
            message={message}
            showDetails={true}
            isRoomLock={isRoomLock}
            beforeMessage={beforeMessage}
            isGroup={isGroup}
            handleDelete={handleDelete}
            canDelete={true}
            className="media"
        >
            <div className="uploaded-media-container">
                <div className={"message-photo"}
                     style={{backgroundImage: `url(${message.previewUrl})`}}
                     onClick={() => handleOpenMedia(message._id)}
                />
            </div>
        </MessageWrapper>
    )
}


const MessageVideo = ({message, beforeMessage, isGroup, isRoomLock, handleDelete, handleOpenMedia}) => {
    let stateStr = [
        'En attente d\'encodage',
        "",
        'Encodage en cours',
        "Erreur d'encodage",
        'Encodage en cours'
    ];

    let state = _.get(message,"file.state") || 0;
    let statusString = stateStr[state];
    return (
        <MessageWrapper
            message={message}
            showDetails={true}
            isRoomLock={isRoomLock}
            beforeMessage={beforeMessage}
            isGroup={isGroup}
            handleDelete={handleDelete}
            canDelete={true}
            className="media"
        >
            <div className={`uploaded-media-container`} >
                <div className={"message-video"}
                     style={{backgroundImage: `url(${message.previewUrl})`}}
                     onClick={() => state === 1 ? handleOpenMedia(message._id) : null}
                >
                    {state === 1 ? <div className={"duration"}><Icon type="play"/> {durationVideo(_.get(message, "file.duration") || 0)}</div> : <div className="thumb-status"> <SpinLoader />{statusString}</div>}
                </div>
            </div>
        </MessageWrapper>
    )
}


const RoomMessage = ({
                         message = {},
                         currentUserId = null,
                         roomOwnerId = null,
                         beforeMessage = {},
                         isGroup = false,
                         isRoomLock = false,
                         handleOpenMedia = () => {
                         },
                         handleDelete = () => {
                         },
                     }) => {
    if(!message.owner){
        message.owner = {
            _id : null,
            username : 'guest'
        }
    }
    message.ownerIsCurrentUser = message.owner._id === currentUserId;

    switch (message.kind) {
        case 'involve':
            return <MessageInvolve
                roomOwnerId={roomOwnerId}
                message={message}
            />;
        case 'text':
            return message.isDeleted
            ?
                <MessageRemove
                    message={message}
                    handleDelete={handleDelete}
                    isRoomLock={isRoomLock}
                    beforeMessage={beforeMessage}
                    isGroup={isGroup}
                />
            : <MessageText
                message={message}
                handleDelete={handleDelete}
                isRoomLock={isRoomLock}
                beforeMessage={beforeMessage}
                isGroup={isGroup}
            />;
        case 'gallery':
            return message.isDeleted
            ? <MessageRemove
                message={message}
                handleDelete={handleDelete}
                isRoomLock={isRoomLock}
                beforeMessage={beforeMessage}
                isGroup={isGroup}
            />
            :<MessageGallery
                handleOpenMedia={handleOpenMedia}
                message={message}
                handleDelete={handleDelete}
                isRoomLock={isRoomLock}
                beforeMessage={beforeMessage}
                isGroup={isGroup}
            />;
        case 'video':
            return message.isDeleted
                ? <MessageRemove
                    message={message}
                    handleDelete={handleDelete}
                    isRoomLock={isRoomLock}
                    beforeMessage={beforeMessage}
                    isGroup={isGroup}
                />
                :<MessageVideo
                    handleOpenMedia={handleOpenMedia}
                    message={message}
                    handleDelete={handleDelete}
                    isRoomLock={isRoomLock}
                    beforeMessage={beforeMessage}
                    isGroup={isGroup}
                />;
        default:
            return <div className="mt-8"/>
    }
}

export default RoomMessage;
